import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoleResponse } from '@app/interface/role';
import { environment } from '@environments/environment';
import { finalize, lastValueFrom } from 'rxjs';
import { ConstantsService } from '@app/services/constants/constants.service';
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(
    private readonly constantsService: ConstantsService,
    public http: HttpClient
  ) {}

  public async getRole() {
    const { PRAGMATIC_PERMISSIONS_PATH } = this.constantsService.app;
    return lastValueFrom(
      this.http
        .get<RoleResponse>(`${environment.webServiceChapter}${PRAGMATIC_PERMISSIONS_PATH}`)
        .pipe(
          finalize(() => {
            localStorage.removeItem('islogin');
          })
        )
    );
  }
}
